import { render, staticRenderFns } from "./CostOfLivingTable.vue?vue&type=template&id=eb6edc3e&"
import script from "./CostOfLivingTable.vue?vue&type=script&lang=js&"
export * from "./CostOfLivingTable.vue?vue&type=script&lang=js&"
import style0 from "./CostOfLivingTable.vue?vue&type=style&index=0&id=eb6edc3e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports